export default __webpack_public_path__ + "media/gs_upgrade_email/logo-1eec467f.png";